/* eslint-disable react/display-name */
import React, {ComponentType, useContext, useMemo} from 'react';
import {IStyles} from '@wix/tpa-settings';
import {useStyles} from '@wix/tpa-settings/react';
import {getBaseShouldRenderValues} from './baseCustomCssVars';
import {useEnvironment} from '@wix/yoshi-flow-editor';

interface AllStylesContext {
  styleParamsForAllBreakpoints: IStyles[];
  shouldRenderVarsForAllBreakpoints: Record<string, boolean>[];
}

const AllStylesContext = React.createContext<AllStylesContext>({} as AllStylesContext);

export function withAllStyles(Component: ComponentType) {
  return (props: any) => {
    const styles = useStyles();
    const {isRTL, isMobile} = useEnvironment();
    const styleParamsForAllBreakpoints = useMemo(() => styles.getStylesForAllBreakpoints(), [styles]);
    const shouldRenderVarsForAllBreakpoints = useMemo(
      () =>
        styleParamsForAllBreakpoints.map((stylesParamsPerBreakpoint) =>
          /* istanbul ignore next */
          getBaseShouldRenderValues({
            booleans: stylesParamsPerBreakpoint.booleans,
            numbers: stylesParamsPerBreakpoint.numbers,
            isMobile,
            isRTL,
          })
        ),
      [styleParamsForAllBreakpoints, isMobile, isRTL]
    );

    return (
      <AllStylesContext.Provider
        value={{
          styleParamsForAllBreakpoints,
          shouldRenderVarsForAllBreakpoints,
        }}>
        <Component {...props} />
      </AllStylesContext.Provider>
    );
  };
}

export function useAllStyles() {
  return useContext(AllStylesContext);
}
